export const getAdminIdFromStoreFrontId: (id: string) => number = (id) =>
  +id.split("/").slice(-1)[0];
